export default () => ({
    loading: true,
    users : [],
    currentUser : null,
    errorMessage: null,
    user: null,
    totals: []
})